<div [class.openMission] = "openMission" *ngIf="_mission">

  <div class="row">
    <div class="col attribute">
      <div class="row">
        <div class="col-sm">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <!-- <img src="assets/images/markers/{{_mission.icon}}" class="icon-type" *ngIf="_mission.icon && !_mission.customIcon">
              <img [src]="_mission.customIcon" class="icon-type" *ngIf="_mission.customIcon"> -->
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Mission name</span>
              </div>
              <!--<button nbButton size="tiny" status="basic" class="btn ml-3" (click)="updateGamesFromMissionTemplate('name',languages)" *ngIf="templateId">Update selected language</button>
              <button nbButton size="tiny" status="basic" class="btn ml-3" (click)="updateGamesFromMissionTemplate('name',initialLanguages)" *ngIf="templateId">Update all languages</button>
              <button nbButton size="tiny" status="basic" class="btn ml-3" (click)="updateGamesFromMissionTemplate(null,initialLanguages)" *ngIf="templateId">Update all fields/languages</button>-->
              <button nbButton *ngIf="!openMission" size="tiny" status="basic" class="btn ml-3" [routerLink]="getEditPath()"><!-- (click)="openPreview()"-->
                <nb-icon icon="eye-outline" pack="eva"></nb-icon> Edit
              </button>
              <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateId && !gameId" (click)="editeRef()">
                <nb-icon icon="edit-outline" pack="eva"></nb-icon> Edit Ref
              </button>
              <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateId && !gameId" (click)="applyChanges(null,null)">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Apply lang changes
              </button>
              <!--<button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateId" (click)="applyStructChanges()">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Apply struct changes
              </button>-->
              <!--<button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateId" (click)="copySdr()">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Copy to rGbMW1kyvEu32S8XoRuB
              </button>-->
              <!--<button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateId" (click)="updateWalter()">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Walter upd.
              </button>-->
              <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="!game" (click)="voiceGeneration()">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Test voice gen
              </button>
              <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateMission && !templateId" (click)="resetFromTemplate()">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Reset from template
              </button>
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-12">
                  <multilang-editor [changes]="_mission.changes" attribute="name" [model]="_mission?.name" [templateModel]="templateMission?.name" [htmlMode]="false" (edit)="editText(_mission?.name, 'name', _mission?.name, false)" 
                    [languages]="languages" [defaultLang]="game?.defaultLang" [showApplyChanges]="templateId && !gameId" (applyChanges)="applyChanges('name',$event)" 
                    (updateFromTemplate)="updateFieldFromTemplate('name')"></multilang-editor>
                  <!--
                  <button nbButton size="tiny" status="basic" class="btn ml-3" (click)="updateGamesFromMissionTemplate('name','fr')" *ngIf="templateId">Test update lang</button>
                  <button nbButton size="tiny" status="basic" class="btn ml-3" (click)="updateGamesFromMissionTemplate('name',null)" *ngIf="templateId">Test update all languages</button>
                  <button nbButton size="tiny" status="basic" class="btn ml-3" (click)="updateGamesFromMissionTemplate(null,null)" *ngIf="templateId">Test update all fields/languages</button>
                  -->
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row" *ngIf="_mission?.description && !isTxtMapEmpty(_mission?.description)">
        <div class="col-12">
          <nb-card [accent]="sectionEdit['description'] ? 'warning' : 'info'" class="mb-2">
            <nb-card-header>
            <span>Mission description</span>
              <!--<div class="d-flex align-items-center justify-content-between w-100">
                <span>Mission description</span>
              </div>-->
            </nb-card-header>
            <nb-card-body>
              <div>
                <!--<multilang-editor [changes]="_mission.changes" attribute="description" [model]="_mission?.description" [templateModel]="templateMission?.description" 
                  (edit)="editText(_mission?.description, 'description', _mission?.description)" 
                  [languages]="languages" [defaultLang]="game?.defaultLang" [showApplyChanges]="templateId" (applyChanges)="applyChanges('description',$event)" 
                  (updateFromTemplate)="updateFieldFromTemplate('description')"></multilang-editor>-->
                <app-block-editor attribute="description" [model]="_mission?.description" [templateModel]="templateMission?.description"
                  [languages]="languages" [defaultLang]="game?.defaultLang"
                  [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                  [voices]="voices" [templateVoices]="templateVoices"
                  [changes]="_mission.changes" [showApplyChanges]="templateId" (applyChanges)="applyChanges('description',$event)" 
                  (updateFromTemplate)="updateFieldFromTemplate('description')"
                  (modelUpdate)="save({description: $event})"></app-block-editor>
                
                
                <div *ngIf="_mission?.audioUrl">
                  <div class="px-3 small text-secondary col-12">Audio description:</div>
                  <audio controls="controls" [src]="_mission?.audioUrl">
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row" *ngIf="_mission?.unlockedDescription"><!-- && !isTxtMapEmpty(_mission?.unlockedDescription)-->
        <div class="col-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
                <span>Unlocked description</span>
            </nb-card-header>
            <nb-card-body>
              <div>
                <!--<multilang-editor attribute="unlockedDescription" [model]="_mission?.unlockedDescription" [templateModel]="templateMission?.unlockedDescription" 
                  [changes]="_mission.changes" (edit)="editText(_mission?.unlockedDescription, 'unlockedDescription', _mission?.unlockedDescription)" 
                  [languages]="languages" [defaultLang]="game?.defaultLang" [showApplyChanges]="templateId" 
                  (applyChanges)="applyChanges('unlockedDescription',$event)" (updateFromTemplate)="updateFieldFromTemplate('unlockedDescription')"></multilang-editor>-->
                <app-block-editor attribute="unlockedDescription" [model]="_mission?.unlockedDescription" [templateModel]="templateMission?.unlockedDescription" 
                  [languages]="languages" [defaultLang]="game?.defaultLang"
                  [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                  [voices]="voices" [templateVoices]="templateVoices"
                  [changes]="_mission.changes" [showApplyChanges]="templateId" (applyChanges)="applyChanges('unlockedDescription',$event)" 
                  (updateFromTemplate)="updateFieldFromTemplate('unlockedDescription')"
                  (modelUpdate)="save({unlockedDescription: $event})"></app-block-editor>
                <div *ngIf="_mission?.unlockedAudioUrl">
                  <div class="px-3 small text-secondary col-12">Unlocked audio:</div>
                  <audio controls="controls" [src]="_mission?.unlockedAudioUrl">
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <nb-card accent="info" class="mb-2" *ngIf="_mission.type == 'FORK'">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Fork text</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="form-group">
                <!--<multilang-editor [changes]="_mission.changes" attribute="forkText" label="Fork text" [model]="_mission?.forkText" 
                  [templateModel]="templateMission?.forkText" (edit)="editText(_mission?.forkText, 'forkText', _mission?.forkText)" 
                  [languages]="languages" [defaultLang]="game?.defaultLang" [showApplyChanges]="templateId" 
                  (applyChanges)="applyChanges('forkText',$event)" 
                  (updateFromTemplate)="updateFieldFromTemplate('forkText')"></multilang-editor>-->
                <app-block-editor attribute="forkText" [model]="_mission?.forkText" [templateModel]="templateMission?.forkText" 
                  [languages]="languages" [defaultLang]="game?.defaultLang"
                  [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                  [voices]="voices" [templateVoices]="templateVoices"
                  [changes]="_mission.changes" [showApplyChanges]="templateId" (applyChanges)="applyChanges('forkText',$event)" 
                  (updateFromTemplate)="updateFieldFromTemplate('forkText')"
                  (modelUpdate)="save({forkText: $event})"></app-block-editor>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="row" *ngIf="_mission.type == 'ROLASSIGN' && _mission.roleAssignMode == 'QUIZZ'">
        <div class="col-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Quizz questions</span>
              </div>
              <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateId && !gameId" (click)="applyChanges('quizzQuestions',null)">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Apply changes (all languages)
              </button>
              <div>
                <div class="row w-100 d-flex align-items-center p-2" *ngIf="_mission.hasChanges('quizzQuestions') && templateMission">
                  <div class="col">
                    <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate('quizzQuestions')">Update from template</button>
                  </div>
                </div>
              </div>
            </nb-card-header>
            <nb-card-body>
              <ng-template ngFor let-question="$implicit" [ngForOf]="_mission.quizzQuestions" let-i="index">
                <div class="row mb-2">
                  <div class="col">
                    <multilang-editor attribute="quizzQuestion" [model]="question.labels" (edit)="editText(question.labels, 'quizzQuestions', _mission?.quizzQuestions)" 
                      [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
    
                    <div class="grid grid-cols-4 gap-4">
                      <div>
                        <div class="px-3 small text-secondary col-12">Role assigned:</div>
                        <div class="px-3 small text-secondary col-12">
                          <div class="object-box" *ngIf="getRole(question.roleId)">
                            <img [src]="getRole(question.roleId).pictureUrl ? getRole(question.roleId).pictureUrl : 'https://placehold.it/50x50'" class="icon-object">
                            <span>{{getRole(question.roleId).labels | txtTranslate}}</span>
                          </div>
                          <div class="object-box" *ngIf="!getRole(question.roleId)">
                            <span class="text-danger">Role {{question.roleId}} not found</span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div *ngIf="question.pictureUrl" class="col-12 p-3">
                          <div class="px-3 small text-secondary col-12">Question picture:</div>
                          <img [src]="question.pictureUrl" class="pic_thumb img-fluid rounded">
                        </div>
                      </div>
                      <div>
                        <div *ngIf="question.audioUrl">
                          <div class="px-3 small text-secondary col-12">Question audio:</div>
                          <audio controls="controls" [src]="question.audioUrl">
                            Your browser does not support the audio element.
                          </audio>
                        </div>
                      </div>
                    </div>
    
                    <div class="" *ngIf="question.activateObjects && question.activateObjects.length>0">
                      <div class="px-3 small text-secondary col-12">Question activates objects:</div>
                      <ul>
                        <ng-template ngFor let-objectId="$implicit" [ngForOf]="question.activateObjects">
                          <li>
                            <div class="object-box" *ngIf="getObject(objectId)">
                              <img [src]="getObject(objectId).pictureUrl ? getObject(objectId).pictureUrl : 'https://placehold.it/50x50'" class="icon-object">
                              <span>{{getObject(objectId).labels | txtTranslate}}</span>
                            </div>
                            <div class="object-box" *ngIf="!getObject(objectId)">
                              <span class="text-danger">Object {{objectId}} not found</span>
                              <button type="button" nbButton size="tiny" status="danger" (click)="deleteListEl(question.activateObjects, objectId, 'quizzQuestions', _mission.quizzQuestions)">Delete</button>
                            </div>
                          </li>
                        </ng-template>
                      </ul>
                    </div>
                  </div>
                </div>
              </ng-template>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="row" *ngIf="_mission.type == 'ROLREVEAL'">
        <div class="col-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Role reveal</span>
              </div>
              <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateId && !gameId" (click)="applyChanges('quizzQuestions',null)">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Apply changes (all languages)
              </button>
              <div>
                <div class="row w-100 d-flex align-items-center p-2" *ngIf="_mission.hasChanges('quizzQuestions') && templateMission">
                  <div class="col">
                    <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate('quizzQuestions')">Update from template</button>
                  </div>
                </div>
              </div>
            </nb-card-header>
            <nb-card-body>
              <ng-template ngFor let-question="$implicit" [ngForOf]="_mission.quizzQuestions" let-i="index">
                <div class="row mb-2">
                  <div class="col">
                    <multilang-editor attribute="quizzQuestion" [model]="question.labels" (edit)="editText(question.labels, 'quizzQuestions', _mission?.quizzQuestions)" 
                      [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
    
                    <div class="grid grid-cols-4 gap-4">
                      <div>
                        <div class="px-3 small text-secondary col-12">Role to reveal:</div>
                        <div class="px-3 small text-secondary col-12">
                          <div class="object-box" *ngIf="getRole(question.roleId)">
                            <img [src]="getRole(question.roleId).pictureUrl ? getRole(question.roleId).pictureUrl : 'https://placehold.it/50x50'" class="icon-object">
                            <span>{{getRole(question.roleId).labels | txtTranslate}}</span>
                          </div>
                          <div class="object-box" *ngIf="!getRole(question.roleId)">
                            <span class="text-danger">Role {{question.roleId}} not found</span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div *ngIf="question.pictureUrl" class="col-12 p-3">
                          <div class="px-3 small text-secondary col-12">Question picture:</div>
                          <img [src]="question.pictureUrl" class="pic_thumb img-fluid rounded">
                        </div>
                      </div>
                      <div>
                        <div *ngIf="question.audioUrl">
                          <div class="px-3 small text-secondary col-12">Question audio:</div>
                          <audio controls="controls" [src]="question.audioUrl">
                            Your browser does not support the audio element.
                          </audio>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="row" *ngIf="_mission.type == 'FORK'">
        <div class="col-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Fork choices</span>
              </div>
              <button nbButton size="tiny" status="basic" class="btn ml-3" *ngIf="templateId && !gameId" (click)="applyChanges('forkSelections',null)">
                <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Apply changes (all languages)
              </button>
              <div *ngIf="!openMission">
                <div class="row w-100 d-flex align-items-center p-2" *ngIf="_mission.hasChanges('forkSelections') && templateMission">
                  <div class="col">
                    <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate('forkSelections')">Update from template</button>
                  </div>
                </div>
              </div>
            </nb-card-header>
            <nb-card-body>
              <ng-template ngFor let-selection="$implicit" [ngForOf]="_mission.forkSelections" let-i="index">
                <div class="row mb-2">
                  <div class="col">
                    <nb-checkbox class="small text-secondary" [checked]="selection.correct"  (change)="checkSelection(i)">Choice #{{i}} ({{selection.uid}})</nb-checkbox>
                    <div *ngIf="getChoiceStats('forkAnswers', selection.uid) | async as nbChoice">Chosen {{ nbChoice }} times</div>
                    <multilang-editor attribute="forkAnswers" [model]="selection.labels" (edit)="editText(selection.labels, 'forkSelections', _mission?.forkSelections)" 
                      [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
    
                    <div class="grid grid-cols-4 gap-4">
                      <div>
                        <div *ngIf="selection.pictureUrl" class="col-12 p-3">
                          <div class="px-3 small text-secondary col-12">Selection picture:</div>
                          <img [src]="selection.pictureUrl" class="pic_thumb img-fluid rounded">
                        </div>
                      </div>
                      <div>
                        <div *ngIf="selection.audioUrl">
                          <div class="px-3 small text-secondary col-12">Selection audio:</div>
                          <audio controls="controls" [src]="selection.audioUrl">
                            Your browser does not support the audio element.
                          </audio>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12" *ngIf="!isTxtMapEmpty(selection.selectedTxt)">
                        <div class="px-3 px-3 small text-secondary">Selected text:</div>
                        <div>
                          <!--<multilang-editor attribute="selectedTxt" [model]="selection.selectedTxt" 
                            (edit)="editText(selection.selectedTxt, 'forkSelections', _mission?.forkSelections)" 
                            [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>-->
                          <app-block-editor [model]="selection.selectedTxt" 
                            [languages]="languages" [defaultLang]="game?.defaultLang"
                            [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                            [voices]="voices" [templateVoices]="templateVoices"
                            [changes]="_mission.changes"
                            (modelUpdate)="selection.selectedTxt = $event; save({forkSelections: _mission.forkSelections})"></app-block-editor>
                        </div>
                      </div>
                      <div class="col-12" *ngIf="!isTxtMapEmpty(selection.unselectedTxt)">
                        <div class="px-3 small text-secondary">Unselected text:</div>
                        <div>
                          <!--<multilang-editor attribute="unselectedTxt" [model]="selection.unselectedTxt" 
                            (edit)="editText(selection.unselectedTxt, 'forkSelections', _mission?.forkSelections)" 
                            [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>-->
                          <app-block-editor [model]="selection.unselectedTxt" 
                              [languages]="languages" [defaultLang]="game?.defaultLang"
                              [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                              [voices]="voices" [templateVoices]="templateVoices"
                              [changes]="_mission.changes"
                              (modelUpdate)="selection.unselectedTxt = $event; save({forkSelections: _mission.forkSelections})"></app-block-editor>
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div *ngIf="selection.reward" class="px-3 small text-secondary col-12">reward points: {{selection.reward}}</div>
                      <div *ngIf="selection.rewardSeconds" class="px-3 small text-secondary col-12">reward seconds: {{selection.rewardSeconds}}</div>
                    </div>
                    <div class="" *ngIf="selection.neededObjects && selection.neededObjects.length>0">
                      <div class="px-3 small text-secondary col-12">Needed objects:</div>
                      <ul>
                        <ng-template ngFor let-object="$implicit" [ngForOf]="getObjects(selection.neededObjects)">
                          <li>
                            <div class="object-box">
                              <img [src]="object.pictureUrl ? object.pictureUrl : 'https://placehold.it/50x50'" class="icon-object">
                              <span>{{object.labels | txtTranslate}}</span>
                            </div>
                          </li>
                        </ng-template>
                      </ul>
                    </div>
    
                    <div class="" *ngIf="selection.activateMissions && selection.activateMissions.length>0">
                      <div class="px-3 small text-secondary col-12">Selection activates missions:</div>
                      <ul>
                        <ng-template ngFor let-missionId="$implicit" [ngForOf]="selection.activateMissions">
                          <li *ngIf="getMission(missionId)">
                            <a [routerLink]="['/pages/game/'+_mission?.gameId+'/overview/'+missionId]">{{getMission(missionId).name | txtTranslate}}</a>
                          </li>
                          <li *ngIf="!getMission(missionId)">
                            <span class="text-danger">Mission {{missionId}} not found</span>
                            <button type="button" nbButton size="tiny" status="danger" (click)="deleteListEl(selection.activateMissions, missionId, 'forkSelections', _mission.forkSelections)">Delete</button>
                          </li>
                        </ng-template>
                      </ul>
                    </div>
                    <div class="" *ngIf="selection.activateObjects && selection.activateObjects.length>0">
                      <div class="px-3 small text-secondary col-12">Selection activates objects:</div>
                      <ul>
                        <ng-template ngFor let-objectId="$implicit" [ngForOf]="selection.activateObjects">
                          <li>
                            <div class="object-box" *ngIf="getObject(objectId)">
                              <img [src]="getObject(objectId).pictureUrl ? getObject(objectId).pictureUrl : 'https://placehold.it/50x50'" class="icon-object">
                              <span>{{getObject(objectId).labels | txtTranslate}}</span>
                            </div>
                            <div class="object-box" *ngIf="!getObject(objectId)">
                              <span class="text-danger">Object {{objectId}} not found</span>
                              <button type="button" nbButton size="tiny" status="danger" (click)="deleteListEl(selection.activateObjects, objectId, 'forkSelections', _mission.forkSelections)">Delete</button>
                            </div>
                          </li>
                        </ng-template>
                      </ul>
                    </div>
                  </div>
                </div>
              </ng-template>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2" *ngIf="_mission.type == 'REWARD' && _mission.rewardMode == 'RIDDLE'">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Riddle</span>
                <div *ngIf="_mission.customRiddle" class="flex flex-row align-items-center">
                  <div class="flex flex-row">
                    <nb-icon icon="checkmark-circle-outline" pack="eva" status="success" *ngIf="_mission.customRiddleVerified"></nb-icon>
                    <nb-icon icon="question-mark-circle-outline" pack="eva" status="warning" *ngIf="_mission.customRiddleProposed && !_mission.customRiddleVerified"></nb-icon>
                    <nb-icon icon="alert-circle-outline" pack="eva" status="danger" *ngIf="!_mission.customRiddleVerified && !_mission.customRiddleProposed"></nb-icon>
                    <span class="ml-1">Custom riddle</span>
                  </div>
                  <div class="flex flex-row align-items-center ml-3" *ngIf="_mission.observationRiddle">
                    <nb-icon icon="eye-outline" pack="eva"></nb-icon>
                    <span class="ml-1">Observation riddle</span>
                  </div>
                </div>
                <button type="button" nbButton size="tiny" status="success" (click)="toggleRiddleVerified()" *ngIf="_mission.customRiddleProposed">Toggle verified</button>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="">
                <div class="">
                  <!--<multilang-editor [changes]="_mission.changes" attribute="riddleText" [model]="_mission?.riddleText" 
                    [templateModel]="templateMission?.riddleText" (edit)="editText(_mission?.riddleText, 'riddleText', _mission?.riddleText)" 
                    [languages]="languages" [defaultLang]="game?.defaultLang" (applyChanges)="applyChanges('riddleText',$event)" 
                    (updateFromTemplate)="updateFieldFromTemplate('riddleText')"></multilang-editor>-->
                  
                  <app-block-editor attribute="riddleText" [model]="_mission?.riddleText" [templateModel]="templateMission?.riddleText" 
                    [languages]="languages" [defaultLang]="game?.defaultLang"
                    [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                    [voices]="voices" [templateVoices]="templateVoices"
                    [changes]="_mission.changes" [showApplyChanges]="templateId" (applyChanges)="applyChanges('riddleText',$event)" 
                    (updateFromTemplate)="updateFieldFromTemplate('riddleText')"
                    (modelUpdate)="save({riddleText: $event})"></app-block-editor>
                  <div *ngIf="_mission?.riddleAudioUrl">
                    <div class="px-3 small text-secondary col-12">Riddle audio:</div>
                    <audio controls="controls" [src]="_mission?.riddleAudioUrl">
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                </div>
              </div>
              <div class="" *ngIf="_mission.riddleAnswerMode !== 'MULTI'">
                <div class="px-3 small text-secondary">Riddle answer:</div>
                <div class="pl-3">
                  <multilang-editor attribute="riddleAnswer" [model]="_mission?.riddleAnswer" [templateModel]="templateMission?.riddleAnswer" [htmlMode]="false" 
                    (edit)="editText(_mission?.riddleAnswer, 'riddleAnswer', _mission?.riddleAnswer, false)" [languages]="languages" [defaultLang]="game?.defaultLang"
                    [changes]="_mission.changes" (applyChanges)="applyChanges('riddleAnswer',$event)" (updateFromTemplate)="updateFieldFromTemplate('riddleAnswer')"></multilang-editor>
                </div>
              </div>
              <div *ngIf="_mission.riddleAnswerMode == 'MULTI'">
                <div *ngIf="!openMission">
                  <div class="row w-100 d-flex align-items-center p-2" *ngIf="_mission.hasChanges('riddleAnswers') && templateMission">
                    <div class="col">
                      <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate('riddleAnswers')">Update from template</button>
                    </div>
                  </div>
                </div>
                <ng-template ngFor let-answer="$implicit" [ngForOf]="_mission.riddleAnswers" let-i="index">
                  <div class="row">
                    <div class="col-12">
                      <nb-checkbox class="small text-secondary" [checked]="answer.correct">Answer #{{i}} ({{answer.uid}})</nb-checkbox>
                      <div *ngIf="getChoiceStats('riddleAnswers', answer.uid) | async as nbChoice">Chosen {{ nbChoice }} times</div>
                      <multilang-editor attribute="riddleAnswers" [model]="answer.labels" htmlMode="false" 
                        (edit)="editText(answer.labels, 'riddleAnswers', _mission?.riddleAnswers)" 
                        [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
                    </div>
                  </div>
                </ng-template>
              </div>
              <div class="">
                <div class="px-3 small text-secondary">Wrong answers sent by teams:</div>
                <div class="pl-3">
                  <ng-template ngFor let-answer="$implicit" [ngForOf]="wrongAnswers" let-i="index">
                    <span class="text-danger mr-1">'{{answer.teamFixedAnswer}}',&nbsp;</span>
                  </ng-template>
                  <button type="button" nbButton size="tiny" status="info" (click)="resetWrongAnswers()">Reset wrong answers</button>
                </div>
              </div>
              
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2" *ngIf="_mission.type == 'REWARD' && (_mission.rewardMode == 'RIDDLE' || _mission.rewardMode == 'AUTO') && _mission.hasExternalLink">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>External game/link</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="">
                <div class="">
                  <multilang-editor [changes]="_mission.changes" attribute="externalUrlLabel" [model]="_mission?.externalUrlLabel" 
                    [templateModel]="templateMission?.externalUrlLabel" (edit)="editText(_mission?.externalUrlLabel, 'externalUrlLabel', _mission?.externalUrlLabel, false)" 
                    [languages]="languages" [defaultLang]="game?.defaultLang" [showApplyChanges]="templateId && !gameId" (applyChanges)="applyChanges('externalUrlLabel',$event)" 
                    (updateFromTemplate)="updateFieldFromTemplate('externalUrlLabel')"></multilang-editor>
                </div>
              </div>
              <div class="">
                <div class="px-3 small text-secondary">External url:</div>
                <div class="pl-3">
                  <a [href]="_mission?.externalUrl" target="_blank" (click)="null" class="external-link">{{_mission.externalUrl}}</a>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      
      <div class="row" *ngIf="_mission.riddleClues && _mission.riddleClues.length>0">
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2" *ngIf="_mission.type == 'REWARD' && (_mission.rewardMode == 'RIDDLE' || _mission.rewardMode == 'QRCODE')">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Clues</span>
              </div>
              <div *ngIf="!openMission">
                <div class="row w-100 d-flex align-items-center p-2" *ngIf="_mission.hasChanges('riddleClues') && templateMission">
                  <div class="col">
                    <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate('riddleClues')">Update from template</button>
                  </div>
                </div>
              </div>

            </nb-card-header>
            <nb-card-body>
              <ng-template ngFor let-clue="$implicit" [ngForOf]="_mission.riddleClues" let-i="index">
                <div class="row mb-2">
                  <div class="col-12">
                    <button *ngIf="(_mission.riddleClues.length - 1) !== i" class="move-buttn" outline type="button" (click)="changePosition(i, i+1)" nbButton size="tiny" status="info">
                      <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
                    </button>
                    <button *ngIf="i !== 0" class="move-buttn" outline type="button" (click)="changePosition(i, i-1)" nbButton size="tiny" status="info">
                      <nb-icon icon="arrow-ios-upward-outline">i</nb-icon>
                    </button>
                    <span class="small text-secondary">Clue #{{i}} ({{clue.uid}})</span>
                    <div *ngIf="getChoiceStats('riddleClues', clue.uid) | async as nbTaken">Taken {{ nbTaken }} times</div>
                    <!--<multilang-editor [changes]="_mission.changes" attribute="riddleClues" [model]="clue.labels" 
                      (edit)="editText(clue.labels, 'riddleClues', _mission?.riddleClues)" 
                      [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>-->
                    <app-block-editor [model]="clue.labels" 
                      [languages]="languages" [defaultLang]="game?.defaultLang"
                      [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                      [voices]="voices" [templateVoices]="templateVoices"
                      [changes]="_mission.changes"
                      (modelUpdate)="clue.labels = $event; save({riddleClues: _mission.riddleClues})"></app-block-editor>
                  </div>
                  <div *ngIf="clue.pictureUrl" class="col-12 p-3">
                    <img [src]="clue.pictureUrl" class="pic_thumb img-fluid rounded">
                  </div>
                  <div class="col-12">
                    <div class="px-3 small text-secondary">
                      Malus: <span>{{clue.riddleClueMalus}} points / {{clue.riddleClueMalusSeconds}} seconds</span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Missions success message</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-12">
                  <!--<multilang-editor [changes]="_mission.changes" attribute="successMessage" [model]="_mission?.successMessage" 
                  [templateModel]="templateMission?.successMessage" (edit)="editText(_mission?.successMessage, 'successMessage', _mission?.successMessage)" 
                    [languages]="languages" [defaultLang]="game?.defaultLang" [showApplyChanges]="templateId" (applyChanges)="applyChanges('successMessage',$event)" 
                    (updateFromTemplate)="updateFieldFromTemplate('successMessage')"></multilang-editor>-->
                  <app-block-editor attribute="successMessage" [model]="_mission?.successMessage" [templateModel]="templateMission?.successMessage" 
                    [languages]="languages" [defaultLang]="game?.defaultLang"
                    [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                    [voices]="voices" [templateVoices]="templateVoices"
                    [changes]="_mission.changes" [showApplyChanges]="templateId" (applyChanges)="applyChanges('successMessage',$event)" 
                    (updateFromTemplate)="updateFieldFromTemplate('successMessage')"
                    (modelUpdate)="save({successMessage: $event})"></app-block-editor>
                </div>
                <div class="col-12" *ngIf="_mission?.successAudioUrl">
                  <div class="small text-secondary">Audio:</div>
                  <audio controls="controls" [src]="_mission?.successAudioUrl">
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    
      <div class="row">
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2" *ngIf="_mission.type == 'REWARD' || _mission.type == 'FZONE'">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Mission failed messages</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="row" *ngIf="!_mission.isEmpty(_mission.failMessage)">
                <div class="col-12">
                  <span class="small text-secondary">Simple fail message</span>
                </div>
                <div class="col-12">
                  <!--<multilang-editor [changes]="_mission.changes" attribute="failMessage" [model]="_mission.failMessage" [templateModel]="templateMission?.failMessage" 
                    (edit)="editText(_mission?.failMessage, 'failMessage', _mission?.failMessage)" 
                    [languages]="languages" [defaultLang]="game?.defaultLang" [showApplyChanges]="templateId" (applyChanges)="applyChanges('failMessage',$event)" 
                    (updateFromTemplate)="updateFieldFromTemplate('failMessage')"></multilang-editor>-->
                  <app-block-editor attribute="failMessage" [model]="_mission?.failMessage" [templateModel]="templateMission?.failMessage" 
                    [languages]="languages" [defaultLang]="game?.defaultLang"
                    [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                    [voices]="voices" [templateVoices]="templateVoices"
                    [changes]="_mission.changes" [showApplyChanges]="templateId" (applyChanges)="applyChanges('failMessage',$event)" 
                    (updateFromTemplate)="updateFieldFromTemplate('failMessage')"
                    (modelUpdate)="save({failMessage: $event})"></app-block-editor>
                </div>
              </div>
              
              <div class="row" *ngIf="_mission.failMessageList && _mission.failMessageList.length>0 && _mission.canRetry">
                <div class="col-12">
                  <span class="small text-secondary">Fail message list</span>
                  <div *ngIf="!openMission">
                    <div class="row w-100 d-flex align-items-center p-2" *ngIf="_mission.hasChanges('failMessageList') && templateMission">
                      <div class="col">
                        <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate('failMessageList')">Update from template</button>
                      </div>
                    </div>
                    <div class="row w-100 d-flex align-items-center p-2" *ngIf="templateId && !gameId">
                      <div class="col">
                        <button nbButton size="tiny" status="basic" class="btn ml-3" (click)="applyChanges('failMessageList',null)">
                          <nb-icon icon="code-download-outline" pack="eva"></nb-icon> Apply changes (all languages)
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <ng-template ngFor let-message="$implicit" [ngForOf]="_mission.failMessageList" let-i="index">
                    <!--<multilang-editor attribute="failMessageList" [model]="message" (edit)="editText(message, 'failMessageList', _mission?.failMessageList)" 
                      [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>-->
                    <app-block-editor [model]="message"
                      [languages]="languages" [defaultLang]="game?.defaultLang"
                      [game]="game" [template]="template" [missionId]="_mission.id" [characters]="characters" 
                      [voices]="voices" [templateVoices]="templateVoices"
                      (modelUpdate)="_mission.failMessageList[i] = $event; save({failMessageList: _mission.failMessageList})"></app-block-editor>
                  </ng-template>
                </div>
              </div>
              <div *ngIf="_mission?.failAudioUrl">
                <div class="px-3 small text-secondary col-12">Audio:</div>
                <audio controls="controls" [src]="_mission?.failAudioUrl">
                  Your browser does not support the audio element.
                </audio>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    </div>

    <div class="col-4 col-lg-3">
      <div class="row">
        <div class="col-12" *ngIf="_mission.latitude && _mission.longitude">
          <nb-card accent="info" class="mb-2">
              <nb-card-header>
                <div class="row">
                  <div class="col-12">
                    <span>Location: {{_mission.location}}</span>
                  </div>
                  <div class="col-12">
                    <span class="text-secondary">
                      <a href="http://maps.google.com/maps?q=&layer=c&cbll={{_mission.latitude}},{{_mission.longitude}}" target="_blank">Google maps</a>
                    </span>
                  </div>
                  <div class="col-12">
                    <button type="button" nbButton size="medium" status="info" (click)="setGameStartLocation()">Set Game start location</button>
                  </div>
                </div>
              </nb-card-header>
              <nb-card-body>
                <google-map class="agm-map" height="300px" width="100%"
                    *ngIf="_mission?.latitude && _mission?.longitude"
                    [options]="mapOptions" [center]="{lat: _mission.latitude, lng: _mission.longitude}">
                    <map-marker
                      [position]="{lat:_mission.latitude, lng:_mission.longitude}"
                      [icon]="{
                        url: _mission.customIcon ? _mission.customIcon : '/assets/images/markers/'+(_mission.icon ? _mission.icon : 'mission_marker.svg'), 
                        scaledSize: !_mission.customIcon && _mission.icon == 'mission_marker.svg' ? {
                          width:40,
                          height:40
                        } : {
                          width: _mission.iconWidth,
                          height: _mission.iconHeight
                        },
                        anchor: !_mission.customIcon && _mission.icon == 'mission_marker.svg' ? {
                          x:20,
                          y:20
                        } : {
                          x:_mission.iconWidth/2,
                          y:_mission.iconHeight/2
                        }}">
                    </map-marker>
                    @if (poi) {
                      <map-marker
                        [position]="{lat:poi.latitude, lng:poi.longitude}"
                        [icon]="{
                          url: poi.getIconUrl(),
                          scaledSize: {
                              width: 40,
                              height: 40
                          }}">
                      </map-marker>
                    }
                </google-map>
              </nb-card-body>
          </nb-card>
        </div>
        <div class="col-12" *ngIf="poi">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Linked POI</span>
                <a nbButton size="tiny" status="basic" class="btn"
                  [routerLink]="['/pages/city/'+poi?.cityId+'/poi/'+_mission?.poiId+'/edit']">
                  <nb-icon icon="edit-outline" pack="eva"></nb-icon> Edit poi
                </a>
                <button type="button" nbButton size="tiny" class="ml-3" status="danger" (click)="deletePoiLink()">Delete link</button>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-12">
                  <span>{{poi.name | txtTranslate}}</span>
                </div>
                <div class="col-12">
                  <span class="text-secondary"><a href="https://www.google.com/maps/search/?api=1&query={{poi.latitude}},{{poi.longitude}}" target="_blank">Google maps</a></span>
                </div>
              </div>

              <div class="row my-2">
                <div class="col-12">
                  <nb-toggle status="info" [ngModel]="_mission?.hidePoiIfNotComplete" (checkedChange)="toggleHidePoi()">POI is hidden until mission is complete</nb-toggle>
                </div>
                <div class="col-12">
                  <nb-toggle status="info" [ngModel]="_mission?.noPoiPopupWhenCompleted" (checkedChange)="toggleNoPoiPopup()">Do not show POI popup when complete</nb-toggle>
                </div>
              </div>
              
              <div class="row my-2" *ngIf="poi.sitelinks">
                <div class="col-auto">Wikipedia links:</div>
                <div class="col-auto" *ngIf="poi.sitelinks['en']">
                  <a href="{{poi.sitelinks['en'].url}}" target="_blank">en</a>
                </div>
                <div class="col-auto" *ngIf="poi.sitelinks['fr']">
                  <a href="{{poi.sitelinks['fr'].url}}" target="_blank">fr</a>
                </div>
                <div class="col-auto" *ngIf="poi.sitelinks['nl']">
                  <a href="{{poi.sitelinks['nl'].url}}" target="_blank">nl</a>
                </div>
              </div>
              <div class="row my-2">
                <div class="col-auto">Description:</div>
                <div class="col-auto">
                  <nb-badge text="en" [status]="poi.description['en']?.length>0 ? 'success' : 'danger'"
                    [nbTooltip]="poi.description['en']" nbTooltipPlacement="top" [nbTooltipStatus]="poi.description['en']?.length>0 ? 'success' : 'danger'">
                  </nb-badge>
                </div>
                <div class="col-auto">
                  <nb-badge text="fr" [status]="poi.description['fr']?.length>0 ? 'success' : 'danger'"
                    [nbTooltip]="poi.description['fr']" nbTooltipPlacement="top" [nbTooltipStatus]="poi.description['fr']?.length>0 ? 'success' : 'danger'">
                  </nb-badge>
                </div>
                <div class="col-auto">
                  <nb-badge text="nl" [status]="poi.description['nl']?.length>0 ? 'success' : 'danger'"
                    [nbTooltip]="poi.description['nl']" nbTooltipPlacement="top" [nbTooltipStatus]="poi.description['nl']?.length>0 ? 'success' : 'danger'">
                  </nb-badge>
                </div>
              </div>
              
              <div class="row my-2">
                <div class="col-auto">Extracts:</div>
                <div class="col-auto">
                  <nb-badge text="en" [status]="poi.extracts['en']?.length>0 ? 'success' : 'danger'"
                    [nbTooltip]="poi.extracts['en']" nbTooltipPlacement="top" [nbTooltipStatus]="poi.extracts['en']?.length>0 ? 'success' : 'danger'">
                  </nb-badge>
                </div>
                <div class="col-auto">
                  <nb-badge text="fr" [status]="poi.extracts['fr']?.length>0 ? 'success' : 'danger'"
                    [nbTooltip]="poi.extracts['fr']" nbTooltipPlacement="top" [nbTooltipStatus]="poi.extracts['fr']?.length>0 ? 'success' : 'danger'">
                  </nb-badge>
                </div>
                <div class="col-auto">
                  <nb-badge text="nl" [status]="poi.extracts['nl']?.length>0 ? 'success' : 'danger'"
                    [nbTooltip]="poi.extracts['nl']" nbTooltipPlacement="top" [nbTooltipStatus]="poi.extracts['nl']?.length>0 ? 'success' : 'danger'">
                  </nb-badge>
                </div>
              </div>
              <div>
                <a href="{{poi.thumbUrl}}" target="_blank">
                  <img [src]="poi.thumbUrl" class="pic_thumb img-fluid rounded">
                </a>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Mission details</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-12">Type: {{_mission.type}}</div>
                <div class="col-12" *ngIf="_mission.type == 'REWARD'">Reward mode: {{_mission.rewardMode}}</div>
              </div>
              
              <div class="row" *ngIf="_mission.rewardMode=='QRCODE' && (!_mission.customQrCode || _mission.customQrCode.length==0)">
                <qrcode [qrdata]="'https://lnk.coddy.app/game/'+_mission.gameId+'/mission/'+_mission.id" [width]="256" [level]="'M'"></qrcode>
                <div class="col-12">QR text: {{'https://lnk.coddy.app/game/'+_mission.gameId+'/mission/'+_mission.id}}</div>
              </div>
              <div class="row" *ngIf="_mission.rewardMode=='QRCODE' && (_mission.customQrCode && _mission.customQrCode.length>0)">
                <qrcode [qrdata]="_mission.customQrCode" [width]="256" [level]="'M'"></qrcode>
                <div class="col-12">QR text: {{_mission.customQrCode}}</div>
              </div>
              <div class="row" *ngIf="_mission.type == 'REWARD' && _mission.rewardMode !== 'MULTI'">
                <div class="col-12">Reward: {{_mission.reward}} points</div>
              </div>
              <div class="row" *ngIf="_mission.type == 'REWARD' && _mission.rewardMode == 'RIDDLE' && riddleAnswerMode == 'MULTI'">
                <div class="col-12">Can retry?: {{_mission.canRetry}}</div>
                <div class="col-12">Malus for wrong answer: {{_mission.riddleMalus}}</div>
              </div>
              <div class="row" *ngIf="_mission.timeLimited">
                <div class="col-12">Time limited mission: {{_mission.timeLimitedSeconds}}</div>
              </div>
              
              <div class="row" *ngIf="_mission.dependencies && (_mission.dependencies | keyvalue).length>0">
                <div class="col-12">Mandatory dependencies:</div>
                <ul>
                  <ng-template ngFor let-dep="$implicit" [ngForOf]="_mission.dependencies | keyvalue">
                    <li *ngIf="getMission(dep.key)">
                      <a [routerLink]="['/pages/game/'+_mission?.gameId+'/overview/'+dep.key]">{{getMission(dep.key)?.name | txtTranslate}}</a>
                    </li>
                    <li *ngIf="!getMission(dep.key)">
                      <span class="text-danger">Mission {{dep.key}} not found</span>
                      <button type="button" nbButton size="tiny" status="danger" (click)="deleteMapEl(_mission.dependencies, dep.key, 'dependencies', _mission.dependencies)">Delete</button>
                    </li>
                  </ng-template>
                </ul>
              </div>
              <div class="row" *ngIf="_mission.optionalDependencies && (_mission.optionalDependencies | keyvalue).length>0">
                <div class="col-12">Optional dependencies (min required:{{optionalDepRequiredNbr}}):</div>
                <ul>
                  <ng-template ngFor let-dep="$implicit" [ngForOf]="_mission.optionalDependencies | keyvalue">
                    <li *ngIf="getMission(dep.key)">
                      <a [routerLink]="['/pages/game/'+_mission?.gameId+'/overview/'+dep.key]">{{getMission(dep.key)?.name | txtTranslate}}</a>
                    </li>
                    <li *ngIf="!getMission(dep.key)">
                      <span class="text-danger">Mission {{dep.key}} not found</span>
                      <button type="button" nbButton size="tiny" status="danger" (click)="deleteMapEl(_mission.optionalDependencies, dep.key, 'optionalDependencies', _mission.optionalDependencies)">Delete</button>
                    </li>
                  </ng-template>
                </ul>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-12" *ngIf="_mission.hasExternalLink">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>External link</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <iframe [src]="externalUrl" class="game-frame" *ngIf="externalUrl"></iframe>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row" *ngIf="pictures && hasPictures(false)">
        <div class="col-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Mission images</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="row justify-content-center">
                <ng-template ngFor let-picture="$implicit" [ngForOf]="pictures">
                  <div *ngIf="!picture.isUnlocked" class="col-sm-12 text-center">
                    <div>
                      <a href="{{picture.url}}" target="_blank">
                        <img [src]="picture.url" class="pic_thumb img-fluid rounded">
                      </a>
                    </div>
                  </div>
                </ng-template>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row" *ngIf="pictures && hasPictures(true)">
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Mission unlocked images</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div class="row justify-content-center">
                <ng-template ngFor let-picture="$implicit" [ngForOf]="pictures">
                  <div *ngIf="picture.isUnlocked" class="col-sm-12 text-center">
                    <div>
                      <a href="{{picture.url}}" target="_blank">
                          <img [src]="picture.url" class="pic_thumb img-fluid rounded">
                      </a>
                    </div>
                  </div>
                </ng-template>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row" *ngIf="_mission.riddleUrl">
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Riddle Image</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div  class="row justify-content-center">
                <div class="col-sm-12 text-center">
                  <a href="{{_mission.riddleUrl}}" target="_blank">
                      <img [src]="_mission.riddleUrl" class="pic_thumb img-fluid rounded">
                  </a>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <ng-template ngFor let-lang="$implicit" [ngForOf]="languageService.languages">
        <div class="row" >
          <div class="col-sm-12">
            <nb-card accent="info" class="mb-2" *ngIf="_mission.riddlePic[lang.code]">
              <nb-card-header>
                <div class="d-flex align-items-center justify-content-between w-100">
                  <span>Language Specific Riddle Image ({{lang.code}})</span>
                </div>
              </nb-card-header>
              <nb-card-body>
                <div  class="row justify-content-center">
                  <div class="col-sm-12 text-center">
                    <a [href]="_mission.riddlePic[lang.code].url" target="_blank">
                      <img [src]="_mission.riddlePic[lang.code].url" class="pic_thumb img-fluid rounded">
                    </a>
                  </div>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </ng-template>

      <div class="row" *ngIf="_mission.successPictureUrl || (_mission.successMissions && _mission.successMissions.length>0) || (_mission.successObjects && _mission.successObjects.length>0)">
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Mission success info </span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div *ngIf="_mission.successPictureUrl" class="row">
                <div>
                  <a href="{{_mission.successPictureUrl}}" target="_blank">
                      <img [src]="_mission.successPictureUrl" class="pic_thumb img-fluid rounded">
                  </a>
                </div>
              </div>
              <div class="row" *ngIf="_mission.successMissions && _mission.successMissions.length>0">
                <div class="col-12">Success activates missions:</div>
                <div class="col-12">
                  <div *ngIf="_mission.successDispatch">Dispatch mode (current dispatch idx:{{_mission.dispatchIndex}})</div>
                  <ul>
                    <ng-template ngFor let-missionId="$implicit" [ngForOf]="_mission.successMissions">
                      <li *ngIf="getMission(missionId)">
                        <a [routerLink]="['/pages/game/'+_mission?.gameId+'/overview/'+missionId]">{{getMission(missionId).name | txtTranslate}}</a>
                      </li>
                      <li *ngIf="!getMission(missionId)">
                        <span class="text-danger">Mission {{missionId}} not found</span>
                        <button type="button" nbButton size="tiny" status="danger" (click)="deleteListEl(_mission.successMissions, missionId, 'successMissions', _mission.successMissions)">Delete</button>
                      </li>
                    </ng-template>
                  </ul>
                  
                  <div *ngIf="!openMission">
                    <nb-alert status="danger" *ngIf="templateMission && _mission.hasChanges('successMissions')">
                      Template
                      <div *ngIf="templateMission.successMissions?.length==0">no data</div>
                      <ul>
                        <ng-template ngFor let-missionId="$implicit" [ngForOf]="templateMission.successMissions">
                          <li *ngIf="getMission(missionId)">
                            {{getMission(missionId).name | txtTranslate}}
                          </li>
                          <li *ngIf="!getMission(missionId)">
                            <span>Unknown mission {{missionId}}</span>
                          </li>
                        </ng-template>
                      </ul>
                      <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate('successMissions')">Update</button>
                    </nb-alert>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="_mission.successObjects && _mission.successObjects.length>0">
                <div class="small text-secondary col-12">Success activates objects:</div>
                <ng-template ngFor let-objectId="$implicit" [ngForOf]="_mission.successObjects">
                  <div class="col">
                    <div class="object-box" *ngIf="getObject(objectId)">
                      <img [src]="getObject(objectId) | objectImage" class="icon-object">
                      <span>{{getObject(objectId).labels | txtTranslate}}</span>
                    </div>
                    <div class="object-box" *ngIf="!getObject(objectId)">
                      <span class="text-danger">Object {{objectId}} not found</span>
                      <button type="button" nbButton size="tiny" status="danger" (click)="deleteListEl(_mission.successObjects, objectId, 'successObjects', _mission.successObjects)">Delete</button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row" *ngIf="_mission.failPictureUrl || (_mission.failMissions && _mission.failMissions.length>0)">
        <div class="col-sm-12">
          <nb-card accent="info" class="mb-2" *ngIf="_mission.type == 'REWARD'">
            <nb-card-header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>Mission failed infos</span>
              </div>
            </nb-card-header>
            <nb-card-body>
              <div *ngIf="_mission.failPictureUrl" class="row">
                <div>
                  <a href="{{_mission.failPictureUrl}}" target="_blank">
                      <img [src]="_mission.failPictureUrl" class="pic_thumb img-fluid rounded">
                  </a>
                </div>
              </div>
              <div class="row" *ngIf="_mission.failMissions && _mission.failMissions.length>0">
                <div class="small text-secondary col-12">Failure activates missions:</div>
                <ul>
                  <ng-template ngFor let-missionId="$implicit" [ngForOf]="_mission.failMissions">
                    <li *ngIf="getMission(missionId)">
                      <a [routerLink]="['/pages/game/'+_mission?.gameId+'/overview/'+missionId]">{{getMission(missionId).name | txtTranslate}}</a>
                    </li>
                    <li *ngIf="!getMission(missionId)">
                      <span class="text-danger">Mission {{missionId}} not found</span>
                      <button type="button" nbButton size="tiny" status="danger" (click)="deleteListEl(_mission.failMissions, missionId, 'failMissions', _mission.failMissions)">Delete</button>
                    </li>
                  </ng-template>
                </ul>
                
                <div *ngIf="!openMission">
                  <nb-alert status="danger" *ngIf="templateMission && _mission.hasChanges('failMissions')">
                    Template
                    <div *ngIf="templateMission.failMissions?.length==0">no data</div>
                    <ul>
                      <ng-template ngFor let-missionId="$implicit" [ngForOf]="templateMission.failMissions">
                        <li *ngIf="getMission(missionId)">
                          {{getMission(missionId).name | txtTranslate}}
                        </li>
                        <li *ngIf="!getMission(missionId)">
                          <span>Unknown mission {{missionId}}</span>
                        </li>
                      </ng-template>
                    </ul>
                    <button type="button" nbButton size="tiny" status="danger" (click)="updateFieldFromTemplate('failMissions')">Update</button>
                  </nb-alert>
                </div>
              </div>
    
            </nb-card-body>
          </nb-card>
        </div>
      </div>

    </div>
  </div>
</div>